/*
 * @Author: Ximen
 * @Date: 2020-12-30 11:07:14
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-14 21:21:40
 */
import axios from 'axios';
import goLink from '@/untils/goLink';
import environment from '../environment';

type method = 'GET' | 'POST' | 'PUT' | 'DELETE';

class Http {
  // constructor() {}

  request =(
    url: string,
    type: method,
    param: {},
    data: {} | null,
    isUploadImg = false,
  ) => new Promise((resolve) => {
    // if (localStorage.getItem('token') && requestRomeo) {
    //   axios.defaults.headers.common.token = localStorage.getItem('token');
    // }
    let apiUrl = '';
    if (environment.type === 'prod') {
      apiUrl = isUploadImg ? `//spapi.saa.s.seatent.com${url}` : environment.baseURL + url;
    } else {
      apiUrl = isUploadImg ? `//spapi.demo.saaspre.seatent.com${url}` : environment.baseURL + url;
    }
    axios({
      method: type,
      url: apiUrl,
      params: {
        ...param,
      },
      data: data || null,
    }).then((res) => {
      if (res.data.code === '911') {
        goLink('/911');
      } else {
        resolve(res.data);
      }
    });
  })

  /**
   * 获取数据方法
   * 拦截器
   * @param {String} url - 请求url
   * @param {Boolean} isMenu - 是否请请求菜单 默认 true
   * @param {Boolean} allowAnonymous - 是否刷新 默认 true
   */
  requestJson = (url: string, allowAnonymous = true) => new Promise((resolve) => {
    // console.log('=====>>>>', axios.defaults.headers.common);
    // axios.defaults.headers.common.token = null;
    axios({
      method: 'get',
      url,
      params: {
        // eslint-disable-next-line @typescript-eslint/camelcase
        ...(allowAnonymous ? { _allow_anonymous: true } : {}),
      },
    }).then((res) => {
      if (res.data.code === '911') {
        goLink('/911');
      } else {
        resolve(res.data);
      }
    });
  })
}
// const Http = new http();
export default Http;
